import * as React from "react";
function SvgLinkfluence(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M4.7 0C2.1 0 0 2.1 0 4.7v38.6C0 45.9 2.1 48 4.7 48h.2c-1.7-1.8-1.7-4.7.1-6.5.8-.8 1.9-1.3 3.1-1.3h.7l2.9-6.3c-3.4-2-4.5-6.5-2.5-9.9.7-1.2 1.8-2.1 3-2.8l-2.7-7.8c-.2 0-.4.2-.5.2-2.7-.1-4.9-2.3-4.9-5.1C4.2 6 6.3 3.9 9 3.9h.1c2.7 0 5 2.1 5.1 4.8 0 1.7-.9 3.3-2.4 4.2l2.7 7.8h1.2c4-.1 7.3 3.1 7.4 7.1v.1c0 .8-.1 1.5-.3 2.2l8.9 4.3c3.4-5.6 10.7-7.3 16.2-3.9 0 0 .1 0 .1.1V4.7c.1-2.5-1.9-4.6-4.4-4.7H4.7zm17 32.1c-1.4 2-3.6 3.1-6 3.1-.7 0-1.3 0-2-.2L11 41.2c1.1.9 1.6 2.2 1.6 3.6 0 1.2-.4 2.4-1.2 3.2h21.4c-1.8-2.1-2.9-4.8-2.9-7.6 0-1.4.2-2.7.7-4l-8.9-4.3z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLinkfluence);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
